import { MainContent } from '@dap/common/ui';
import { PropsWithChildren } from 'react';

export default function DefaultPageTemplate({ children }: PropsWithChildren) {
  return <MainContent>{children}</MainContent>;
}
